import styled from "styled-components";

import { TColorScheme } from "@/configs/themes/colors.types";

import { FONT_VARIANTS } from "../Typography";

export const Container = styled.span<{ $color: TTableBadgeColor; $borderless?: boolean; $colorScheme: TColorScheme }>`
    padding: 4px 8px;
    color: ${props => props.theme.components.tableBadge[props.$color].color};
    background-color: ${props => props.theme.components.tableBadge[props.$color].bgColor};
    border: 1px solid;
    border-color: ${props => props.$borderless
    ? "transparent"
    : props.theme.components.tableBadge[props.$color].borderColor
};
    white-space: nowrap;
    border-radius: 100px;
    ${FONT_VARIANTS.small};
`;
